<template>
    <div class="rechargeinvite">
        <div class="inviteBox">
            <div class="inviteRow inviteRow_1">
                <div class="rowTitle">新用户获得：</div>
                <div>
                    <el-select v-model="form.wasInvitedRule.coupons" placeholder="请选择" @change="couponsChange">
                        <el-option :label="item.label" :value="item.value" v-for="item in form.wasInvitedRule.couponsNumList" :key="item.value"></el-option>
                    </el-select>
                </div>
                <div>
                    <el-select v-model="form.wasInvitedRule.couponsTypeText" placeholder="请选择卡券">
                        <el-option :label="item.couponName" :value="item.couponId" v-for="item in couponsTypeList" :key="item.couponId" @click.native="wasInvitedBtn(item)"></el-option>
                    </el-select>
                </div>
            </div>

            <el-divider></el-divider>
            <div class="title">邀请后、领取新用户数量：</div>
            <div class="inviteRow inviteRow_2" v-for="(item,index) in form.inviteRule" :key="index">
                <span class="text">邀请</span>
                <el-input class="input" v-model="item.inviteNum" clearable placeholder="请输入" />
                <span class="text">(人)送</span>
                <div>
                    <el-select v-model="item.couponType" placeholder="请选择卡券">
                        <el-option :label="j.label" :value="j.value" v-for="j in item.couponsList" :key="j.value" @click.native="couponTypeChange(item,j.value)"></el-option>
                    </el-select>
                </div>
                <div>
                    <el-select v-model="item.couponName" placeholder="请选择卡券">
                        <el-option :label="j.couponName" :value="j.couponName" v-for="j in item.give" :key="j.couponId" @click.native="couponsClick(item,j)"></el-option>
                    </el-select>
                </div>
                <i class="el-icon-circle-plus" @click="addTimeRow(1,item,index)"></i>
                <i class="el-icon-delete" v-if="form.inviteRule.length > 1" @click="delTimeRow(1,index)"></i>
            </div>
            <el-divider></el-divider>
            <div class="title">邀请后、领取新用户消费金额：</div>
            <div>
                <div class="inviteRow inviteRow_3" v-for="(item,index) in form.consumptionRule" :key="index">
                    <span class="text">消费</span>
                    <el-input class="input" v-model="item.consumptionAmount" clearable placeholder="请输入" />
                    <span class="text">(元)送</span>
                    <el-select v-model="item.couponType" placeholder="请选择卡券" @change="userNumChange(item)">
                        <el-option :label="j.label" :value="j.value" v-for="j in item.couponsList" :key="j.value"></el-option>
                    </el-select>
                    <el-select v-model="item.couponName" placeholder="请选择卡券">
                        <el-option :label="j.couponName" :value="j.couponName" v-for="j in item.give" :key="j.couponId" @click.native="amountClick(item,j)"></el-option>
                    </el-select>
                    <i class="el-icon-circle-plus" @click="addTimeRow(2,item,index)"></i>
                    <i class="el-icon-delete" v-if="form.consumptionRule.length > 1" @click="delTimeRow(2,index)"></i>
                </div>

            </div>

        </div>
    </div>
</template>

<script>
import requstsMethod from "common/const";
import { response } from "network/response";
export default {
    data () {
        return {
            coupons: '',
            couponsType: '',
            changeNum: 0,
            billiardsId: JSON.parse(this.$store.state.billiardsInfo).billiardsId,  //商户id
            couponsNumList: [
                {
                    value: 2,
                    label: '水机券',
                },
                {
                    value: 1,
                    label: '台费券',
                },
            ],
            couponsTypeList: [],
            couponUseScopeType: '',
        }
    },
    props: ['form', 'addType'],
    methods: {
        // 被邀请用户Change
        couponsChange (val) {
            this.couponUseScopeType = val
            this.couponsBtn(val)
        },
        wasInvitedBtn (item) {
            console.log(item);
            let obj = {
                couponAmount: item.amount,
                couponId: item.couponId,
                couponName: item.couponName,
                couponNum: item.useScopeType,
                couponUseScopeType: item.useScopeType,
                userId: null
            }
            let ary = []
            ary.push(obj)
            this.form.wasInvitedRule.give = ary
        },
        // 获取被邀请获得优惠券
        async couponsBtn (val) {
            const params = {
                billiardsId: this.billiardsId,
                useScopeType: val,
                pageNo: 1,
                pageSize: 100,
                useTime: this.form.endDate
            }
            const data = await response(requstsMethod.fun_Get_authorized_marketing_coupons_list, params)
            // this.form.wasInvitedRule.give = data.list[0]
            this.couponsTypeList = data.list
        },
        // 领取数量 Change
        async couponTypeChange (item, val) {
            console.log(item, '222');
            item.give = []
            const params = {
                billiardsId: this.billiardsId,
                useScopeType: val,
                pageNo: 1,
                pageSize: 100,
                useTime: this.form.endDate
            }
            const data = await response(requstsMethod.fun_Get_authorized_marketing_coupons_list, params)
            let obj = {
                couponName: '请选择',
                couponId: null,
            }
            item.give = data.list
            item.give = [obj, ...item.give];
            this.couponsBtn(item.couponUseScopeType)
        },
        couponsClick (item, j) {
            item.couponId = j.couponId
            item.couponName = j.couponName
            item.couponNum = item.inviteNum
            item.couponUseScopeType = j.useScopeType
            item.consumptionAmount = j.amount
            console.log(item, '9999');
        },
        async userNumChange (item) {
            console.log(item);
            const params = {
                billiardsId: this.billiardsId,
                useScopeType: item.couponType,
                pageNo: 1,
                pageSize: 100,
                useTime: this.form.endDate
            }
            const data = await response(requstsMethod.fun_Get_authorized_marketing_coupons_list, params)
            let obj = {
                couponName: '请选择',
                couponId: null,
            }
            item.give = data.list
            item.give = [obj, ...item.give];
        },
        amountClick (item, j) {
            item.couponId = j.couponId
            item.couponName = j.couponName
            item.couponNum = item.couponName
            item.couponUseScopeType = j.useScopeType
            console.log(item, '8888');
        },
        addTimeRow (val, item, index) {
            console.log(item);
            if (val == 1) {
                this.form.inviteRule.map((res, i) => {
                    if (index == i) {
                        let obj = {
                            consumptionAmount: item.amount,
                            give: item.give,
                            couponAmount: null,
                            couponId: '',
                            couponName: '',
                            couponNum: 0,
                            couponUseScopeType: 0,
                            userId: null,
                            couponsList: [
                                {
                                    value: 1,
                                    label: '台费券',
                                },
                                {
                                    value: 2,
                                    label: '水机券',
                                },
                            ],
                        }
                        this.form.inviteRule.push(obj)
                    }
                })
            } else {
                this.form.consumptionRule.map((res, i) => {
                    if (index == i) {
                        let obj = {
                            consumptionAmount: '',
                            give: item.give,
                            couponId: '',
                            couponName: '',
                            couponUseScopeType: 0,
                            couponsList: [
                                {
                                    value: 1,
                                    label: '台费券',
                                },
                                {
                                    value: 2,
                                    label: '水机券',
                                },
                            ],
                        }
                        this.form.consumptionRule.push(obj)
                    }
                })
            }
        },
        delTimeRow (val, index) {
            if (val == 1) {
                this.form.inviteRule.map((res, i) => {
                    if (i == index) {
                        this.form.inviteRule.splice(index, 1)
                    }
                })
            } else {
                this.form.consumptionRule.map((res, i) => {
                    if (i == index) {
                        this.form.consumptionRule.splice(index, 1)
                    }
                })
            }
        },

        async configFn (close) {
            if (!this.form.wasInvitedRule.coupons || this.form.wasInvitedRule.coupons == '' || this.form.wasInvitedRule.couponsType == '') {
                this.$message({ message: '请选择新用户奖励', type: 'error' });
            } else {
                // 被邀请获得
                let wasInvitedRuleConfig = {
                    consumptionAmount: null,
                    give: this.form.wasInvitedRule.give,
                    inviteNum: null
                }
                // 邀请数量
                let inviteRuleConfig = []
                this.form.inviteRule.map(item => {
                    if (item.inviteNum == '' || item.inviteNum == 0) {
                        this.$message({ message: '请输入邀请人数', type: 'error' });
                    } else {
                        let give = []
                        let giveObj = {
                            couponId: item.couponId,
                            couponName: item.couponName,
                            couponUseScopeType: item.couponUseScopeType,
                        }
                        give.push(giveObj)
                        let configObj = {
                            inviteNum: item.inviteNum,
                            give: give,
                            consumptionAmount: null
                        }
                        inviteRuleConfig.push(configObj)
                    }
                })
                // 邀请消费金额
                let consumptionRuleConfig = []
                this.form.consumptionRule.map(item => {
                    console.log(item, '009900');
                    if (item.consumptionAmount !== '') {
                        let give = []
                        let giveObj = {
                            couponId: item.couponId,
                            couponName: item.couponName,
                            couponUseScopeType: this.couponUseScopeType,
                        }
                        give.push(giveObj)
                        let configObj = {
                            consumptionAmount: item.consumptionAmount,
                            give: give,
                            inviteNum: null
                        }
                        consumptionRuleConfig.push(configObj)
                    } else {
                        this.$message({ message: '请填写消费金额', type: 'error' });
                    }
                })
                const params = {
                    billiardsId: this.billiardsId,
                    id: this.form.activityId,
                    name: this.form.name,
                    remark: this.form.remark,
                    status: null,
                    templateType: this.form.type,
                    startTime: this.form.creatDate,
                    endTime: this.form.endDate,
                    ruleConfig: {
                        consumptionRule: consumptionRuleConfig,
                        inviteRule: inviteRuleConfig,
                        wasInvitedRule: wasInvitedRuleConfig
                    },
                }
                console.log(params);
                const data = await response(requstsMethod.fun_service_authorized_activity_task_save, params)
                if (data.pass) {
                    this.$message({ message: `${this.addType == 'add' ? '添加' : '修改'}成功`, type: 'success' });
                    close()
                } else {
                    this.$message({ message: `${this.addType == 'add' ? '添加' : '修改'}失败，${data.errorLine[0].type}`, type: 'error' });
                }
            }
        },
        getClear () {

        }
    }
}
</script>

<style lang="scss">
.rechargeinvite {
    width: 100%;
    .inviteBox {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        .title {
            color: #fff;
            font-size: 16px;
            font-weight: 600;
            letter-spacing: 1px;
            margin: 10px 0 20px 30px;
        }
        .inviteRow {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            margin: 10px 0;
            .rowTitle {
                color: #fff;
                font-size: 16px;
                font-weight: 600;
                letter-spacing: 1px;
                margin-left: 30px;
            }
            .text {
                color: #fff;
                font-size: 16px;
                font-weight: 600;
                letter-spacing: 1px;
                display: inline-block;
                margin-left: 10px;
            }
            .input {
                width: 100px;
                margin-left: 10px;
                .el-input__inner {
                    width: 100px;
                    height: 40px;
                    line-height: 40px;
                    color: #fff;
                    border: none;
                    background-color: #3e3e3e;
                    box-shadow: 0 0 5px #000 inset;
                }
            }
            .el-select {
                width: 260px;
                margin: 0 10px;
                .el-input__inner {
                    height: 40px;
                    line-height: 40px;
                    color: #fff;
                    border: none;
                    background-color: #3e3e3e;
                    box-shadow: 0 0 5px #000 inset;
                }
            }
            .el-icon-circle-plus {
                font-size: 20px;
                margin-right: 20px;
                cursor: pointer;
            }
            .el-icon-circle-plus:hover {
                color: #409eff;
            }
            .el-icon-delete {
                font-size: 20px;
                cursor: pointer;
            }
            .el-icon-delete:hover {
                color: #fd4747;
            }
        }
        .inviteRow_2 {
            padding-left: 30px;
        }
        .inviteRow_3 {
            padding-left: 30px;
        }
    }
}
</style>